import {FCX} from "@datassential/platform-ui-lib";
import cn from "classnames";
import Wrapper from "@components/Wrapper";

const AnalyzePerformanceWrapper: FCX = ({
    className,
    testId,
    children,
}) => {
    return (
        <div
            className={
                cn("AnalyzePerformanceWrapper", className)
            }
            data-testid={testId}
        >
            <Wrapper>
                {children}
            </Wrapper>
        </div>
    )
}

export default AnalyzePerformanceWrapper;